import { useQuery } from "@tanstack/react-query";
import { get } from "../components/utils/request";
import { useAuthStore } from "../stores/authStore";
const fetchUserData = async ({ token }) => {
  const response = await get({
    path: "/auth/data-user",
    token,
  });
  return response;
};

export const useUserData = () => {
  const { auth } = useAuthStore();
  const userDataQuery = useQuery({
    queryKey: ["userData"],
    queryFn: () => fetchUserData({ token: auth.accessToken }),
    refetchInterval: 1000 * 60 * 5,
    enabled: !!auth.accessToken,
  });

  return {
    userDataQuery,
  };
};
